import { MainColor } from '../../palette';

export const statusTheme = {
  green: {
    symbolText: 'green80' as MainColor,
    symbolBackground: 'green30' as MainColor,
    dotTextBorder: 'green30' as MainColor,
    dotTextText: 'green50' as MainColor,
    dotColor: 'green50' as MainColor,
    dotBorder: 'green60' as MainColor,
  },
  red: {
    symbolText: 'red80' as MainColor,
    symbolBackground: 'red40' as MainColor,
    dotTextBorder: 'red30' as MainColor,
    dotTextText: 'red50' as MainColor,
    dotColor: 'red50' as MainColor,
    dotBorder: 'red60' as MainColor,
  },
  orange: {
    symbolText: 'orange80' as MainColor,
    symbolBackground: 'orange40' as MainColor,
    dotTextBorder: 'orange40' as MainColor,
    dotTextText: 'orange50' as MainColor,
    dotColor: 'orange40' as MainColor,
    dotBorder: 'orange50' as MainColor,
  },
  blue: {
    symbolText: 'navy80' as MainColor,
    symbolBackground: 'navy40' as MainColor,
    dotTextBorder: 'navy30' as MainColor,
    dotTextText: 'navy50' as MainColor,
    dotColor: 'navy50' as MainColor,
    dotBorder: 'navy60' as MainColor,
  },
  grey: {
    symbolText: 'coolGrey80' as MainColor,
    symbolBackground: 'coolGrey40' as MainColor,
    dotTextBorder: 'coolGrey30' as MainColor,
    dotTextText: 'coolGrey50' as MainColor,
    dotColor: 'coolGrey50' as MainColor,
    dotBorder: 'coolGrey60' as MainColor,
  },
  yellow: {
    symbolText: 'yellow80' as MainColor,
    symbolBackground: 'yellow30' as MainColor,
    dotTextBorder: 'yellow30' as MainColor,
    dotTextText: 'yellow50' as MainColor,
    dotColor: 'yellow30' as MainColor,
    dotBorder: 'yellow50' as MainColor,
  },
  brown: {
    symbolText: 'brown80' as MainColor,
    symbolBackground: 'brown40' as MainColor,
    dotTextBorder: 'brown30' as MainColor,
    dotTextText: 'brown50' as MainColor,
    dotColor: 'brown50' as MainColor,
    dotBorder: 'brown60' as MainColor,
  },
  violet: {
    symbolText: 'violet80' as MainColor,
    symbolBackground: 'violet40' as MainColor,
    dotTextBorder: 'violet30' as MainColor,
    dotTextText: 'violet50' as MainColor,
    dotColor: 'violet50' as MainColor,
    dotBorder: 'violet60' as MainColor,
  },
  rose: {
    symbolText: 'rose80' as MainColor,
    symbolBackground: 'rose40' as MainColor,
    dotTextBorder: 'rose30' as MainColor,
    dotTextText: 'rose50' as MainColor,
    dotColor: 'rose50' as MainColor,
    dotBorder: 'rose60' as MainColor,
  },
  iconDot: {
    circleIconBorder: 'coolGrey20' as MainColor,
    circleIconBg: 'coolGrey5' as MainColor,
    circleIconColor: 'coolGrey60' as MainColor,
  },
} as const;

export type StatusTheme = typeof statusTheme;
